import React from 'react';
import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';

import { PORTAL_ACCENT } from '../../../styles/portalTheme';

const ActionIconButton = styled(IconButton)(({ theme, bordercolor, iconcolor }) => ({
  width: 36,
  height: 36,
  borderRadius: 8,
  border: `1px solid ${bordercolor ?? theme.palette.divider}`,
  color: iconcolor ?? theme.palette.text.secondary,
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const EventRowActions = ({ onView, onEdit, onDelete, onArchive, eventId }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
    <ActionIconButton aria-label="View event" onClick={() => onView?.(eventId)}>
      <VisibilityOutlinedIcon sx={{ fontSize: 18 }} />
    </ActionIconButton>
    {onEdit ? (
      <ActionIconButton
        bordercolor="#2196f3"
        iconcolor="#2196f3"
        aria-label="Edit event"
        onClick={() => onEdit(eventId)}
      >
        <EditOutlinedIcon sx={{ fontSize: 18 }} />
      </ActionIconButton>
    ) : null}
    {onArchive ? (
      <ActionIconButton
        bordercolor="#e6b48f"
        iconcolor={PORTAL_ACCENT}
        aria-label="Archive event"
        onClick={() => onArchive(eventId)}
      >
        <ArchiveOutlinedIcon sx={{ fontSize: 18 }} />
      </ActionIconButton>
    ) : null}
    {onDelete && !onArchive ? (
      <ActionIconButton
        bordercolor="#f44336"
        iconcolor="#f44336"
        aria-label="Delete event"
        onClick={() => onDelete(eventId)}
      >
        <DeleteOutlineOutlinedIcon sx={{ fontSize: 18 }} />
      </ActionIconButton>
    ) : null}
  </Box>
);

export default EventRowActions;
